<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="名称" prop="name"><el-input v-model="formParameter.name"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属产品" prop="productId">
							<el-select v-model="formParameter.productId" clearable placeholder="请选择产品">
								<el-option v-for="item in productList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="迭代状态" prop="state">
							<select-option-dictionary v-model="formParameter.state"
								dkey="spr-backlog-states"></select-option-dictionary>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="总人日" prop="allManDay"><el-input placeholder="单位是天" min="0" type="number"
								v-model="formParameter.allManDay" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="负责团队" prop="teamId">
							<el-select v-model="formParameter.teamId" clearable placeholder="请选择团队,没有先空着后面补选">
								<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="开始时间" prop="startTime">
							<el-date-picker v-model="formParameter.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束时间" prop="endTime">
							<el-date-picker v-model="formParameter.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注" prop="remarks">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }"
								v-model="formParameter.remarks" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row> <el-row>
					<el-col :span="24">
						<el-form-item label="迭代目标" prop="goal">
							<wang-edit :isupdt="isUpdtWedit" v-model="formParameter.goal"></wang-edit>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button @click="close">取 消</el-button>
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>

		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/sprint/sprint/sprint.js';
import productApi from '@/api/product/product/product.js';
import teamApi from '@/api/team/team/team.js';
import wangEdit from '@/components/wangEdit/wangEdit.vue';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		wangEdit
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			productList: [],
			teamList: [],
			isUpdtWedit: false,   //用于更新wangEdit
			teamNm: '',
			rules: {
				//人日
				allManDay: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.range,
						min: "0",
						trigger: 'blur'
					}
				],
				//sprint开始时间
				startTime: [
					{
						validator: this.$validate.required,
						trigger: "blur",
					},
				],
				//sprint结束时间
				endTime: [
					{
						validator: this.$validate.required,
						trigger: "blur",
					},
				]
			},
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {

			this.parameter = parameter;

			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;

			this.formParameter = {}
			this.isUpdtWedit = true
			setTimeout(() => {
				this.isUpdtWedit = false
			}, 100)

			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			// 未分配Sprint的团队
			teamApi.list({ hasSprint: 0 }, response => {
				this.teamList = response.data.records;
				if (this.formParameter.teamId) {
					this.teamList.push({ id: this.formParameter.teamId, name: this.parameter.tName })
				}
				this.listLoading = false;
			});


			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {

					this.formParameter = response.data;

					// 未分配Sprint的团队
					teamApi.list({ hasSprint: 0 }, response => {
						this.teamList = response.data.records;
						if (this.formParameter.teamId) {
							this.teamList.push({ id: this.formParameter.teamId, name: this.parameter.tName })
						}
						this.listLoading = false;
					});



					//vue模型毛病
					if (this.formParameter.goal) {
						this.isUpdtWedit = true
						setTimeout(() => {
							this.isUpdtWedit = false
						}, 100)
					}

					this.popupLoading = false;
				});
			}else{
				this.formParameter = this.parameter
			}
			//添加			
			this.popupLoading = false;
			this.productList = this.$caches.products.get();
			if (!this.productList) {
				//获取产品数据并存入productData
				productApi.list4Select({}, response => {
					this.productList = response.data;
				})
			}

		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
